import type { Metadata, Viewport } from 'next'

export const metadata: Metadata = {
  title: 'Luxury Day Spa and Massage Thailand | Oasis Spa Thailand',
  keywords:
    'spa,Oasis spa,spa near me,thai massage near me,day spa,the oasis spa thailand,oasis spas,best spa near me,best thai massage near me,luxurious spa,best thai massage,luxury thai spa,body massage,spa near me,day spa near me,thai spa near me,day spa near me,oasis spa thailand,the oasis spa,spa booking online,best spa,treatment,best thai spa near me,book online spa,luxury spa,oasis day spa,spa for kids,relax,Spa treatment',
  description:
    'Oasis Spa is one of the best luxury day spa, Oasis Spa provide the spa experience by combining Lanna secrets with advanced discoveries in beauty and wellness.',
  robots: { index: true, follow: true },
  icons: [
    { rel: 'icon', url: '/static/favicon-32x32.png', type: 'image/png', sizes: '32x32' },
    { rel: 'apple-touch-icon', url: '/static/apple-touch-icon.png', type: 'image/png' }
  ],
  manifest: '/manifest.webmanifest'
}

export const viewport: Viewport = {
  width: 'device-width',
  initialScale: 1,
  colorScheme: 'only light',
  themeColor: [
    { media: '(prefers-color-scheme: dark)', color: '#040404' },
    { media: '(prefers-color-scheme: light)', color: '#fef9f1' }
  ]
}
